import type { DialogModalConfig, ModalProps } from '@common';

export interface WelcomeModalConfig extends DialogModalConfig {
  canHide?: boolean;
  onConfirm?: (cheked: boolean) => void;
}

export interface WelcomeModalProps extends ModalProps {
  config: WelcomeModalConfig;
}

export enum HideWelcomeModal {
  SHOW = 'show',
  HIDE = 'hide'
}
